export function initializePageLoaded() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const addLoaded = () => document.body.classList.add('loaded');

  if (document.readyState === 'complete') {
    addLoaded();
    return;
  }

  const MAX_WAIT_MS = 2500;
  const timeoutId = window.setTimeout(addLoaded, MAX_WAIT_MS);

  window.addEventListener(
    'load',
    () => {
      window.clearTimeout(timeoutId);
      addLoaded();
    },
    { once: true },
  );
}
